import React from 'react';
import clsx from 'clsx';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

import Video from '@common/blocks/flex/Video';
import Buttons from '@common/blocks/flex/Buttons';
import Images from '@common/blocks/flex/Images';
import Links from '@common/blocks/flex/Links';
import MobileLinks from '@common/blocks/flex/MobileLinks';

import { 
  benefitQuote,
  benefitQuoteMargin
} from '@styles/modules/careers.module.scss';
import * as styles from '@common/blocks/flex/flex.module.scss';

const ImageQuotes = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    showImages,
    imagePosition,
    imagePositionTop,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    buttons,
    images,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        'py-5': bgColour && !bgNoPadding,
        'container card': !bgFullwidth,
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <div className={clsx(`d-flex flex-column align-items-center`, {
            'flex-xl-row-reverse': imagePosition === 'Left',
            'flex-xl-row': imagePosition === 'Right',
            'flex-column-reverse': imagePositionTop,
            'justify-content-center': !images && textAlignment === 'Center'
          })}>
          {(text || buttons) &&
            <div className={clsx('col', {
                'text-center col-lg-10': images && imagePosition === 'Center',
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
              })}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p='mb-3'
                  li='py-2'
                  a='fs-16'
                  ul={listClass}
                />
              }
              {buttons && 
                <Buttons data={data} />
              }
            </div>
          }
          {images &&
            <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx({
                [`d-none ${showImages}`]: showImages,
                'mb-3 mb-xl-0': imagePositionTop,
                [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
              })}>
              {images.map((image, index) => (
                <div key={index} className={clsx('d-none d-sm-flex flex-row justify-content-between', {['flex-row-reverse']:index%2 == 0, [benefitQuoteMargin]:index!==0})}>
                  <div className={`d-flex flex-column pe-4`}>
                    {image.description && <p className={clsx(`fs-18 font-italic`, benefitQuote)}>{`"${image.description}"`}</p>}
                    {image.title && <span className={`font-italic`}>{`- ${image.title.split('~')[0]}`}</span>}
                    {image.title.split('~')[1] && <span className={`font-italic`}>{`${image.title.split('~')[1]}`}</span>}
                  </div>
                  <Img image={image.gatsbyImageData} file={image.file} style={{maxWidth: '289px'}} aria-hidden={true} />
                </div>
              ))}
            </div>
          }
        </div>
      </Container>
    </Section>
  )
}

export default ImageQuotes
